import { render, staticRenderFns } from "./Letters.vue?vue&type=template&id=20e1574e&"
import script from "./Letters.vue?vue&type=script&lang=js&"
export * from "./Letters.vue?vue&type=script&lang=js&"
import style0 from "./Letters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports